'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const Guid=require('pulsar-utils/dist-es6/domain/guid');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const ex=require('pulsar-utils/dist-es6/ex');

const InitialFatigueThreshold=Number.POSITIVE_INFINITY;let


PersonalFatigueThresholdService=function(_BaseService){_inherits(PersonalFatigueThresholdService,_BaseService);_createClass(PersonalFatigueThresholdService,null,[{key:'$inject',get:function()
{return['groupsCommandAndQueryService','organizationDefaultsService']}}]);

function PersonalFatigueThresholdService(groupsCommandAndQueryService,organizationDefaultsService){_classCallCheck(this,PersonalFatigueThresholdService);var _this=_possibleConstructorReturn(this,
_BaseService.call(this));
_this._groupsCommandAndQueryService=groupsCommandAndQueryService;
_this._organizationDefaultsService=organizationDefaultsService;return _this;
}PersonalFatigueThresholdService.prototype.

getTresholdAndGroupInfoFor=function(){var ref=_asyncToGenerator(function*(personId){
personId=personId.toString();
const[flattenedGroups,organizationDefaults]=yield Promise.all([
this._groupsCommandAndQueryService.getFlattenedGroups(),
this._organizationDefaultsService.getOrganizationThresholds()]);


const directGroups=flattenedGroups.filter(function(group){return _.includes(group.personIds,personId)});

if(directGroups.length===0){
return{
groupMemberships:[],
fatigueThreshold:organizationDefaults.fatigueThreshold,
deviationThreshold:organizationDefaults.deviationThreshold};

}

directGroups.forEach(function(group){
group.fatigueThreshold=ex(group.fatigueThreshold).otherwise(organizationDefaults.fatigueThreshold);
group.deviationThreshold=ex(group.deviationThreshold).otherwise(organizationDefaults.deviationThreshold);
});

const fatigueSort=function(g){return g.fatigueThreshold};
const deviationSort=function(g){return-g.deviationThreshold};

const groupsSortedByFatigueThreshold=_.sortBy(directGroups,fatigueSort);
const groupsSortedByDeviationThreshold=_.sortBy(groupsSortedByFatigueThreshold,deviationSort);

return{
groupMemberships:_.sortBy(directGroups,[fatigueSort,deviationSort]),
fatigueThreshold:groupsSortedByFatigueThreshold[0].fatigueThreshold,
deviationThreshold:groupsSortedByDeviationThreshold[0].deviationThreshold};

});function getTresholdAndGroupInfoFor(personId){return ref.apply(this,arguments)}return getTresholdAndGroupInfoFor}();return PersonalFatigueThresholdService}(BaseService);


module.exports=PersonalFatigueThresholdService;
//# sourceMappingURL=personalFatigueThresholdService.js.map
